<template>
    <div class="screenManageView innerMainContent">
        <div class="innerHeader">
            <div class="h1Wrap">
                <svg class="i_users"><use xlink:href="#i_users"></use></svg>
                <div class="innerH1Wrap">
                    <h1>{{ $t('page_title_screen') }}</h1>
                    <ul class="breadcrumb">
                        <li><a href="#">{{ $t('menu_hp') }}</a></li>
                        <li v-if="this.$store.state.user.type == 2"><router-link v-bind:to="'/event/wedding/'+$store.state.event.id">{{ $t('event') }}</router-link></li>
                        <li class="active">{{ $t('page_title_screen') }}</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <div class="innerBox inviteBox" v-if="$store.state.event.hasSms">
                    <div class="textSide">
                        <h2>
                            <span>{{ $t('invitationImage') }}</span>
                            <svg class="i_info"><use xlink:href="#i_info"></use></svg>
                        </h2>
                        <div class="body">{{ $t('whatImageInvitation') }}</div>
                    </div>
                    <div class="imgSide">
                        <img src="/static/images/zug.jpg" alt="">
                    </div>
                </div>
                <div class="innerBox galleryBox">
                    <h2>
                        <span>{{ $t('imagesGallery') }}</span>
                        <svg class="i_info"><use xlink:href="#i_info"></use></svg>
                    </h2>
                    <div class="body">{{ $t('backgroundImages') }}</div>
                    <div class="row imgesWrapper">
                        <ScreenImageUpload v-for="i in 4" :id="(i-1)" v-on:change="saveImage" :key="(i-1)"></ScreenImageUpload>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xs-12">
                <div class="innerBox">
                    <h2>
                        <span>איזה סגנון אתם אוהבים?</span>
                        <svg class="i_info"><use xlink:href="#i_info"></use></svg>
                    </h2>
                    <div id="imageCarusel" class="owl-carousel owl-theme" data-carousel='{"items":3,"nav":true,"dots":true,"loop":true,"center":true,"autoplay":false,"smartSpeed":700,"navText":["<span class=\"sr-only\">הקודם</span><svg class=\"i_select\"><use xlink:href=\"#i_select\"></use></svg>","<span class=\"sr-only\">הבא</span><svg class=\"i_select\"><use xlink:href=\"#i_select\"></use></svg>"],"navElement":"button","rtl":true}'>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                            <div class="hoverEl"><svg><use xlink:href="#i_v"></use></svg></div>
                        </div>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                        </div>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                        </div>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                        </div>
                    </div>

                </div>

            </div>
        </div>


    </div>
</template>

<script>
    import ScreenImageUpload from './ScreenImageUpload'
    export default {
        name: "Screen",
        components: {
            ScreenImageUpload
        },
        mounted(){
            $(document).ready(function() {
                $.getScript("/static/js/owl.carousel.min.js", function () {
                    function initCarousel(obj, opts) {
                        $(obj).owlCarousel(opts);
                        let pp = $(obj).data("pp");
                        if (pp) {
                            if (pp == ".playPauseWrapper") {
                                $(".playPauseWrapper").append("<button class='playPauseBtn'><svg class='i_play'><use xlink:href='#i_play'></use></svg><svg class='i_pause'><use xlink:href='#i_pause'></use></svg><span class='sr-only'>עצור גלריה אוטמטית</span></button>");
                            } else {
                                if (pp == ".owl-nav") {
                                    $(obj).find('.owl-nav').find('.owl-prev').after("<button class='playPauseBtn'><svg class='i_play'><use xlink:href='#i_play'></use></svg><svg class='i_pause'><use xlink:href='#i_pause'></use></svg><span class='sr-only'>עצור גלריה אוטמטית</span></button>");
                                } else {
                                    $(obj).find(pp).prepend("<button class='playPauseBtn'><svg class='i_play'><use xlink:href='#i_play'></use></svg><svg class='i_pause'><use xlink:href='#i_pause'></use></svg><span class='sr-only'>עצור גלריה אוטמטית</span></button>");
                                }
                            }
                            $(obj).parent().find('.playPauseBtn').click(function (e) {
                                if ($(this).hasClass('paused')) {
                                    obj.trigger('play.owl.autoplay');
                                    $(this).removeClass("paused");
                                    $(this).find('span').html("עצור גלריה אוטמטית");
                                } else {
                                    obj.trigger('stop.owl.autoplay', [1000]);
                                    $(this).addClass("paused");
                                    $(this).find('span').html("הפעל גלריה אוטמטית");
                                }
                            });
                        }

                    }

                    $(".owl-carousel[data-carousel]:not(.manual)").each(function () {
                        $(this).owlCarousel($(this).data("carousel"))
                    });

                    $("body").on('click', '.reportsBtn', function (e) {
                        e.preventDefault();
                        let target = $('#modal-reports');
                        target.iziModal('open');
                    });

                });
            });
        },
        methods:{
            saveImage(_ = {}){
              if(typeof _.imageID !=='undefined' && _.imageID != null && _.fileID){
                  _.id = this.$store.state.event.id;
                  this.$store.dispatch('kioskImageUpload',_)
                      .then(res =>{
                          this.$store.state.event = res;
                      })
                                          .catch(err => {
                                              //err
                                              this.$swal({
                                                  confirmButtonText:this.$t('okButton'),
                                                  type:'error',
                                                  title:this.$t('opFailed'),
                                                  timer:3000
                                              }).catch(this.$swal.noop);
                                              console.warn('failed to upload file ' + err.toString());
                                          })
              }
            }
        },
        beforeMount(){
            if(this.$store.state.user.type == 3 && !this.$store.state.event.id){
                this.$router.push('/');
                return;
            }else {
                if(this.$store.state.user.type === 3) this.$router.currentRoute.param = {eventID:this.$store.state.event.id};
                if (typeof this.$router.currentRoute.params !== 'undefined' && this.$router.currentRoute.params.eventID != '') {
                    this.$store.state.event = {type:{},gallery:{}};
                    this.$store.dispatch('getEvent',this.$router.currentRoute.params.eventID)
                                            .then(response =>{
                                                //success
                                                this.$store.state.event = response.data;
                                            })
                                            .catch(err => {
                                                //err
                                                this.$store.state.event = {type:{},gallery:{}};
                                                this.$router.push('/')
                                            })
                } else {
                    this.$router.push('/');
                    this.$store.state.event = {type:{},gallery:{}};
                }
            }
        }
    }
</script>
<style scoped>

    h3{
        color: #293b5a;
        font-weight: 700;
        font-size:1.059rem;
    }
    .innerMainContent{
        padding:55px 45px;
        float: right;
        width:100%;
    }

    .h1Wrap .i_users{
        width:36px;
        height:28px;
    }
    .innerBox{
        padding:40px;
    }
    .innerBox h2{
        text-align: center;
        margin-bottom:40px;
    }
    .innerBox h2 span{
        color:#293b5a;
        font-weight: 700;
        font-size: 1.765rem;
        display: inline-block;
        vertical-align: middle;
    }
    .innerBox h2 svg{
        width: 22px;
        height: 22px;
        display: inline-block;
        vertical-align: middle;
        margin-right: 5px;
        fill:#ff0000;
    }

    .owl-stage-outer{
        padding:50px 0;
    }
    .owl-carousel.owl-rtl .owl-item.active.center{
        transform: scale(1.2);
        box-shadow: 0px 1px 35px 0px rgba(0, 0, 0, 0.29);
        z-index: 1;
    }
    .imageWrap{
        border:1px solid #909090;
        position: relative;
    }
    .imageWrap .hoverEl{
        position: absolute;
        top:50%;
        right:50%;
        transform: translate(50%,-50%);
        width:62px;
        height:62px;
        background: #fff;
        border-radius: 50%;
        border:2px solid #7892c0;
    }
    .imageWrap .hoverEl svg{
        height:62px;
        width:32px;
        fill:#7892c0;
        display: block;
        margin:0 auto;
    }
    .owl-carousel{
        width:90%;
        margin:0 5%;
    }
    .owl-dots{
        text-align: center;
    }
    .owl-dot{
        display: inline-block;
        padding: 0 3px;
    }
    .owl-dot span{
        width:9px;
        height:9px;
        border-radius: 50%;
        display: block;
        background: #cdcdcd;
    }
    .owl-dot.active span{
        background: #7994c2;
    }
    .owl-next,
    .owl-prev{
        position: absolute;
        top:50%;
    }
    .owl-prev{
        transform: rotate(-90deg);
        right:-50px;

    }

    .owl-next{
        transform: rotate(90deg);
        left:-50px;

    }
    .owl-next svg,
    .owl-prev svg{
        width:29px;
        height:17px;
        fill:#7893c1;
    }
    .inviteBox{
        padding:0;
        margin-bottom:30px;
    }
    .inviteBox .textSide{
        width: 45%;
        float: right;
        text-align: right;
        padding: 15px;
    }
    .inviteBox .textSide h2{
        text-align: right;
        margin-bottom: 10px;
    }
    .inviteBox .imgSide{
        width: 55%;
        float: right;
        max-height: 210px;
        overflow: hidden;
    }
    .imgSide img{
        min-width: 100%;
    }
    .galleryBox{
        text-align: right;
        padding:15px;
    }
    .galleryBox h2{
        text-align: right;
        margin-bottom:10px;
    }
    .imgesWrapper{
        margin: 0 -7px;
        margin-top:45px;
    }
    .imgesWrapper div[class^="col-"]{
        padding:0 7px;
    }
    .imageItem{
        border:1px solid #d7d7d7;
        background: #f1f1f1;
        width:100%;
        height:90px;
        overflow: hidden;
        position: relative;
    }
    .imageItem img{
        width:100%;
    }
    .imageItem .hoverEl{
        position: absolute;
        top:100%;
        right:0;
        width:100%;
        height:100%;
        background: rgba(41,59,90,0.74);
        text-align: center;
        line-height: 90px;
        transition: top .25s ease-in-out;
        -moz-transition: top .25s ease-in-out;
        -webkit-transition: top .25s ease-in-out;
    }
    .imageItem:focus .hoverEl,
    .imageItem:hover .hoverEl{
        top:0;
        transition: top .25s ease-in-out;
        -moz-transition: top .25s ease-in-out;
        -webkit-transition: top .25s ease-in-out;
    }
    .imageItem .hoverEl button{
        display: inline-block;
    }
    .imageItem .hoverEl button.deleteImg svg{
        fill:#fff;
        width:19px;
        height:27px;
    }
    .imageItem .hoverEl button.ImgAction svg{
        fill:#fff;
        width:30px;
        height:27px;
    }

    .imageItem .fileInputWrap{
        width: 100%;
        height: 100%;
    }
    .imageItem .fileInputWrap input[type=file]{
        width: 100%;
        height: 100%;
    }
    .imageItem .fileInputWrap svg.i_files{
        height:90px;
        width:29px;
        top: 0;
        right: 50%;
        transform: translateX(50%);
    }
    #modal-reports.iziModal{
        text-align: center;
        background: transparent;
        box-shadow: none;
        max-width: 700px!important;
    }
    #modal-reports.iziModal .iziModal-content{
        padding:0!important;
    }
    #modal-reports h2{
        color:#fff;
        font-size: 2.529rem;
    }
    #modal-reports h3{
        color:#fff;
        font-size: 1.353rem;
        margin-top: 15px;

    }
    #modal-reports .i_event_tab{
        width:76px;
        height:44px;
        fill:#fff;
        margin-bottom:20px;
    }
    #modal-reports ul{
        text-align: center;
        margin-top:80px;
    }
    #modal-reports ul li{
        display: inline-block;
        padding: 0 25px;
    }
    #modal-reports ul li a{
        display: block;
    }

    #modal-reports .iconWrap{
        width:116px;
        height:116px;
        border:2px solid #50c5bf;
        border-radius: 50%;
        margin:0 auto;
        background: transparent;
        transition: all .25s ease-in-out;
        -moz-transition: all .25s ease-in-out;
        -webkit-transition: all .25s ease-in-out;
    }

    #modal-reports .iconWrap svg{
        fill:#fff;
        height:112px;
    }
    #modal-reports .iconWrap svg.seatingData{width:31px;}
    #modal-reports .iconWrap svg.arrivinigData{width:40px;}
    #modal-reports .iconWrap svg.guestData{width:52px;}
    #modal-reports .iconWrap svg.guestArriveData{width:45px;}
    #modal-reports .reportTxt{
        font-size: 1.118rem;
        color:#fff;
        margin:10px 0;
    }
    #modal-reports .i_download{
        width: 20px;
        height:28px;
        fill:#fff;
    }
    #modal-reports ul li a:hover,
    #modal-reports ul li a:focus {
        text-decoration: none;
    }
    #modal-reports ul li a:hover .iconWrap,
    #modal-reports ul li a:focus .iconWrap{
        background: #273347;
        transition: all .25s ease-in-out;
        -moz-transition: all .25s ease-in-out;
        -webkit-transition: all .25s ease-in-out;
    }
    #modal-reports ul li a:hover .i_download,
    #modal-reports ul li a:focus .i_download{
        fill: #55ddd0;
        transition: all .25s ease-in-out;
        -moz-transition: all .25s ease-in-out;
        -webkit-transition: all .25s ease-in-out;
    }


    @media only screen and (max-width:1450px){
        .tabsWrap li a span{font-size: 1rem;}
        .tabsWrap li a svg{margin-left: 5px;}
    }
</style>
